module.exports = __webpack_public_path__ + "static/html-994edc66cc52d3b3102227c78c86acd8.png";